import Vue from 'vue'
import { mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import configs from '@/config'
import utils from '@/util'

export default (component) => Vue.component('QnAModerationLinkContainer', {
  data() {
    return {
      moderationLink: '',
      generatingModerationLink: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  watch: {
    'presentation.moderationCode': function watchCurrentUser() {
      this._generateModerationLink(this.presentation.moderationCode)
    },
  },
  mounted() {
    this._generateModerationLink(this.presentation.moderationCode)
  },
  methods: {
    async handleGenerateModerationLink() {
      this.generatingModerationLink = true
      try {
        this.presentation.moderationCode =
            await PresentationApi.generateModerationCode(this.presentation.id, {
              uniqueAccessCode: this.presentation.uniqueAccessCode,
            })
        this._generateModerationLink(this.presentation.moderationCode)
      } catch (error) {
        utils.showToastError(this.$i18nPresenter.t('Generate link failed'))
        if (error.status) {
          throw error
        }
      } finally {
        this.generatingModerationLink = false
      }
    },

    _generateModerationLink(moderationCode) {
      if (!moderationCode) return
      this.moderationLink = `${configs.backstageDomain}/${moderationCode}`
    },

    openModerationLinkInNewTab() {
      window.open(this.moderationLink, '_blank')
    },

    showToasterCopySuccess() {
      utils.showToastSuccess(this.$i18nPresenter.t('Link copied!'))
    },
  },
  render(createElement) {
    return createElement(component, {
      props: {
        handleGenerateModerationLink: this.handleGenerateModerationLink,
        moderationLink: this.moderationLink,
        openModerationLinkInNewTab: this.openModerationLinkInNewTab,
        showToasterCopySuccess: this.showToasterCopySuccess,
        generatingModerationLink: this.generatingModerationLink,
      },
    })
  },
})
